import { CircularProgress, Fade, Grid, makeStyles, Tooltip, Typography, withStyles } from '@material-ui/core';
import { blueGrey, grey } from '@material-ui/core/colors';
import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../utils/context'
import nodata from '../assets/images/nodata.png'
import LoadingContainer from './LoadingContainer';
import CardLevelQR from './CardLevelQR';
import useCardLevels from '../hooks/modules/cardlevels/useCardLevels';
import CardLevelQRModal from './Modals/CardLevelQRModal';


const CardLevelTableDetails = ({data}) => {

    const classes = useStyles()
    const program = data
    const cardlevelManager = useCardLevels()
    const card_levels = cardlevelManager.data.cardlevels
    const [card_level, setCardLevel] = useState()
    const [qrModal, setQrModal] = useState(false)

    useEffect(() => {
        if(data) cardlevelManager.actions.onGetCardLevels(data.idProgram)
    }, [data])

    const onOpenQrModal = (_data) => {
        setCardLevel(_data)
        setQrModal(true)
    }

    const onCloseQRModal = () => {
        setQrModal(false)
        setCardLevel(null)
    }

    const onQRUpdated = async() => {
        try {
            const cardlevels = await cardlevelManager.actions.onGetCardLevels(data.idProgram)
            const selected = cardlevels.find(el => 
                card_level?.idProgram === el.idProgram 
                && card_level?.idCardLevel === el.idCardLevel 
            )
            setCardLevel(selected)
        } catch (error) {
            
        }
    }
    

    //const [loading, setLoading] = useState(false)
    //const [card_levels, setCardLevets] = useState([])
    

    /*useEffect(() => {

        const initModule = async() => {
            setLoading(true)
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                const cardlevel_rq = await axios.get(`/cardLevel/program/${data.idProgram}/all`)
                setCardLevets(cardlevel_rq.data.data)

                console.log(cardlevel_rq.data.data)
            } catch (error) {
                setCardLevets([])
            }
            setLoading(false)
        }
        if(data) initModule()
    }, [data])*/

    const loading = cardlevelManager.system.loading

    

    return ( 
        <div className={classes.root}>
            
            <Typography className={classes.title}>
                Card Levels
            </Typography>

                <CardLevelQRModal 
                    open={qrModal}
                    onClose={onCloseQRModal}
                    origin={card_level}
                    onCompleted={onQRUpdated}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className={classes.header}>
                            <Grid container spacing={2} wrap='nowrap'>
                                <Grid item xs>
                                    <Typography className={classes.cell_header} variant='body2' color='inherit'>Description</Typography>
                                </Grid>
                                <Grid item >
                                    <Typography style={{width:120}} className={classes.cell_header} variant='body2' color='inherit'>Card Image</Typography>
                                </Grid> 
                                <Grid item >
                                    <Typography style={{width:120}} className={classes.cell_header} variant='body2' color='inherit'>Merchant Logo</Typography>
                                </Grid>
                                <Grid item >
                                    <Typography style={{width:120}} className={classes.cell_header} variant='body2' color='inherit'>Issuer Brand</Typography>
                                </Grid>
                                <Grid item >
                                    <Typography style={{width:120}} className={classes.cell_header} variant='body2' color='inherit'>QR Code</Typography>
                                </Grid>
                            </Grid>
                        </div>    
                    </Grid>
                    {loading ? (
                        <Grid item xs={12}>
                            <div style={{padding:'32px 16px'}}>
                                <Grid container justify='center' direction='column' alignItems='center'>
                                    <Grid item>
                                        <CircularProgress />
                                    </Grid>
                                    <Grid item>
                                        <Typography style={{color:grey[700]}}>Searching...</Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    ) : null}
                    {card_levels.map(item => {
                        
                        return(
                            <Grid item xs={12} key={`cld-${item.idProgram}-${item.idCardLevel}`}>
                                <div className={classes.row}>
                                    <Grid container spacing={2}>
                                        <Grid item xs>
                                            <Typography variant='subtitle1' className={classes.description}>{item.description}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <div className={classes.cell_body}>
                                                <div className={classes.image_container}>
                                                    <img src={item.backgroundImageUrl} alt='' className={classes.image} />
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <Grid container spacing={2} alignItems='center'>
                                                <Grid item>
                                                    <div className={classes.cell_body}>
                                                        <LightTooltip title={item.merchantDescription}>
                                                            <div className={classes.image_container}>
                                                                <img src={item.merchantLogo} alt='' className={classes.image} />
                                                            </div>
                                                        </LightTooltip>
                                                    </div>
                                                </Grid>
                                                <Grid item>
                                                    <div className={classes.cell_body}>
                                                        <LightTooltip title={item.cardBrandDescription}>
                                                            <div className={classes.image_log_container}>
                                                                <img src={item.cardBrandLogo} alt='' className={classes.image} />
                                                            </div>
                                                        </LightTooltip>
                                                    </div>
                                                </Grid>
                                                <Grid item>
                                                    <div className={classes.cell_body}>
                                                        <CardLevelQR 
                                                            url={item?.qrCode} 
                                                            onClick={() => onOpenQrModal(item)}
                                                            size={256}
                                                            />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        
                                        
                                        
                                        
                                    </Grid>
                                </div>
                            </Grid>
                        )
                    })}
                    {card_levels.length === 0 && !loading ? (
                        <Grid item xs={12}>
                            <div style={{padding:'32px 16px'}}>
                                <Grid container direction='column' alignItems='center'>
                                    <Grid item>
                                        <img src={nodata} alt='No data' width={70}/>
                                    </Grid>
                                    <Grid item>
                                        Sorry! No records found
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                        
                    ) : null}
                </Grid>
            
        </div>

     );
}

const useStyles = makeStyles(theme => ({
    root:{
        padding:12
    },
    header:{
        color:blueGrey[500],
        paddingBottom:8,
        borderBottom:`1px solid ${grey[300]}`
    },
    cell_header:{
        fontWeight:700,
        

    },
    cell_body:{
        width:120,
    },
    row:{
        paddingBottom:8,
        borderBottom:`1px solid ${grey[300]}`
    },
    title:{
        fontWeight:600,
        color:theme.palette.primary.main,
        marginBottom:16,
        textTransform:'uppercase'
    },
    caption:{
        fontSize:14,
        color:blueGrey[400],
    },
    description:{
        lineHeight:1.0,
        color:blueGrey[900],
        fontWeight:500
    },
    image_container:{
        width:90,
        height:90,
    },
    image_log_container:{
        width:60,
        height:60,
    },
    image:{
        width:'100%',
        height:'100%',
        objectFit:'contain',
        objectPosition:'center'
    }

}))
 
export default CardLevelTableDetails;


const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#3f51b5",
      color: 'white',
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
}))(Tooltip);